import React from 'react';

const ResultText = (props) => {

	if (props.length && props.isCyoa) {
		return (
			<div className="cyoa-onboarding">
		    <p className="results-text">
		      We have found <span className="bold">{props.length} popular itineraries</span> to get you inspired
		    </p>
			   <p className="small-12 medium-10 large-8 medium-centered text-center">Pick an itinerary you like, add or remove destinations and Adventures, choose how long you want to stay in each destination, and select your accommodation. It couldn't be easier!</p>
	    </div>
  	)
	}
	else if(props.length === 0 && props.isCyoa){
		return(
		<div className="cyoa-onboarding">
			<p className="results-text">
				We have found <span className="bold">{props.length} popular itineraries</span> to get you inspired
			</p>
			<p className="small-12 medium-10 large-8 medium-centered text-center">
				Oops no itineraries matching your selection, please re-search or alternatively use our <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_BUILDER_PAGE}`}>Trip wizard</a>
			</p>
		</div>
		)
	}
	else if (props.length && !props.isCyoa) {
		return (
		<div className="cyoa-onboarding">
		    <p className="results-text">
		      <span className="bold">{props.length} trips</span> found
		    </p>
	    </div>
	    )
	} else {
		return (
				''
			)
	}
}

export default React.memo(ResultText);



// WEBPACK FOOTER //
// ./src/components/shared/results-text.js